import type { BaseIssue } from 'valibot';

/**
 * 1つのメッセージにつき列挙する該当箇所の上限。
 * 同じ間違いが大量にあるとき、全件を並べてもAIの修正には繋がらずツール結果が肥大するだけなので打ち切る。
 */
const MAX_PATHS_PER_MESSAGE = 10;

/** valibot の issue のパスを views[0].links[2].style.themeColor の形に整形する。 */
function formatIssuePath(issue: BaseIssue<unknown>): string {
  if (!issue.path || issue.path.length === 0) return '(root)';

  return issue.path
    .map((item, index) => {
      if (typeof item.key === 'number') return `[${item.key}]`;
      return index === 0 ? String(item.key) : `.${String(item.key)}`;
    })
    .join('');
}

/**
 * 編集系ツール(addView/patchView)の入力がスキーマに合わなかったときに、
 * AIへ返すツール実行結果の文言を組み立てる。
 *
 * 同じ原因の指摘は1件にまとめる。要素ごとに同じ行を並べると個別の書き間違いに見えてしまい、
 * AIが「その項目のルール」として受け取れず、別の非対応値で再試行してエラーを繰り返すため。
 */
export function formatToolInputValidationError(issues: readonly BaseIssue<unknown>[]): string {
  const locationsByMessage = new Map<string, { path: string; received: string }[]>();
  for (const issue of issues) {
    const locations = locationsByMessage.get(issue.message) ?? [];
    locations.push({ path: formatIssuePath(issue), received: issue.received });
    locationsByMessage.set(issue.message, locations);
  }

  const lines = [...locationsByMessage].map(([message, locations]) => {
    const shown = locations
      .slice(0, MAX_PATHS_PER_MESSAGE)
      .map((location) => `${location.path}（受け取った値: ${location.received}）`);
    const omitted = locations.length - shown.length;
    return `- ${message}\n  該当箇所: ${shown.join(', ')}${omitted > 0 ? `, ほか${omitted}件` : ''}`;
  });

  return (
    'データの形式が間違っているので修正してください｡指摘された箇所を直してから呼び出し直してください' +
    '（同じ値のまま再実行しても同じエラーになります）。\n' +
    lines.join('\n')
  );
}
